import axios from "axios";
import {Message, MessageBox} from "element-ui";
// import store from '@/store'
import {getApiBase} from "@/utils/index";
import router from "@/config/router.js";
// create an axios instance
const service = axios.create({
    baseURL: getApiBase(),
    // request timeout
});

// request interceptor
service.interceptors.request.use(
    (config) => {
        // do something before request is sent
        const token = localStorage.getItem("token");
        if (token != undefined && token != "") {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers["token"] = token;
        }
        return config;
    },
    (error) => {
        // do something with request error
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    (response) => {
        const res = response.data;

        if (res.__abp) {
            return handleResponse(response);
        }

        // if the custom code is not 20000, it is judged as an error.
        if (response.status !== 200 && response.status !== 401) {
            Message({
                message: res.message || "Error",
                type: "error",
                duration: 5 * 1000,
            });

            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
                // to re-login
                MessageBox.confirm(
                    "You have been logged out, you can cancel to stay on this page, or log in again",
                    "Confirm logout",
                    {
                        confirmButtonText: "Re-Login",
                        cancelButtonText: "Cancel",
                        type: "warning",
                    }
                ).then(() => {
                    store.dispatch("resetToken").then(() => {
                        location.reload();
                    });
                });
            }
            return Promise.reject(new Error(res.message || "Error"));
        } else {
            return res;
        }
    },
    (error) => {
        if (error.message == 'Network Error') {
            Message({
                message: "请检查本地医保服务是否已启动",
                type: "error",
                duration: 5 * 1000,
            });
            return;
        }
        if (error.response.data.__abp) {
            return handleResponse(error.response);
        }
        if (error.response.status === 401) {
            // Token失效，执行相应操作
            // 例如，跳转到登录页面或执行退出登录操作
            Message({
                message: error.response.data.msg || "Error",
                type: "error",
                duration: 5 * 1000,
            });
            router.push('/login')
        } else {
            Message({
                message: error.message,
                type: "error",
                duration: 5 * 1000,
            });
        }

        return Promise.reject(error);
    }
);


window.request = service;
export default service;
